import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { Manufacturer } from '../../../../interfaces/manufacturer';

const stringToNumberArray = (str: string) => {
  if (!str || str.trim() === '') return [];

  return str
    .split(',')
    .map(item => item.trim()) // удаляем пробелы
    .filter(item => item !== '') // удаляем пустые элементы
    .map(Number) // преобразуем в числа
    .filter(num => !Number.isNaN(num)); // удаляем не числа
};

export function useManufacturerSearch({
  initCheck,
  setSelected,
}: {
  initCheck?: boolean;
  setSelected?: React.Dispatch<React.SetStateAction<Manufacturer[]>>;
}) {
  const [load, setLoad] = useState(initCheck);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category');
  const manufacturer = searchParams.get('mnfc');
  const idsManufacturer = stringToNumberArray(manufacturer || '');

  const checkManufacturer = async () => {
    // if (category) {
    // const manufacturers: Manufacturer[] = await fetch({
    //   category_id: category ? Number(category) : undefined,
    //   page: 1,
    //   per_page: 9999,
    // });
    // const idsManufacturer = stringToNumberArray(manufacturer || '');
    // const newManufacturer = manufacturers.filter(item => idsManufacturer.includes(item.id));
    // setMnfc(String(newManufacturer.map(item => item.id).join(',')));
    // setSelected?.(newManufacturer);
    // } else {
    //   clear();
    //   setSelected?.([]);
    // }
    setTimeout(() => {
      setLoad(false);
    }, 100);
  };

  // useEffect(() => {
  //   if (!category) {
  //     clear();
  //     setSelected?.([]);
  //   };
  // }, [category]);

  useEffect(() => {
    if (initCheck) {
      checkManufacturer();
    }
  }, []);

  const setMnfc = (ids: string) => {
    setSearchParams(searchParams => {
      searchParams.set('mnfc', ids);
      return searchParams;
    });
  };

  const setSearchValues = (data: { field: string; value?: string }[]) => {
    setSearchParams(searchParams => {
      data.map(i => {
        if (!i.value) {
          searchParams.delete(i.field);
        } else {
          searchParams.set(i.field, i.value);
        }
      });
      return searchParams;
    });
  };

  const clear = () => {
    setSearchParams(searchParams => {
      searchParams.delete('mnfc');
      return searchParams;
    });
  };

  return {
    manufacturer: initCheck && load ? null : manufacturer || null,
    setMnfc,
    clear,
    load,
    idsManufacturer,
    url: location.search,
    setSearchValues,
  };
}
